import type { GeneralConfig } from '@shared/types/Config';

export const transactionTypeConfig: GeneralConfig = {
    sortFieldMap: {
        'inventory_type.data.name': 'inventory_types|name',
    },
};
